import Vue from 'vue'
import select from 'dom-select'

Vue.component('form-newsletter', {
  props: [
    'url',
    'group'
  ],
  data () {
    return {
      query: {
        g: this.group,
        $fields: ['email'],
        $source: 'Subscription Form'
      },
      response: false,
      hasError: false,
      loading: false
    }
  },
  methods: {
    onInputChange ({ name, value }) {
      this.query[name] = value
    },
    submit (e) {
      e.preventDefault()
      const isValid = this.$children.every(c => c.validate())
      if (!isValid) {
        return
      }
      this.loading = true

      window.sessionStorage.setItem('newsletter', 'closed')
      select('#ContactFooter').submit()
    }
  }
})
